import { useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useSiteNavHidden } from './siteNavAutoHide';

/**
 * When the phone tab bar shows (2026-10-01; mockup: the "LYF Tab Bar"
 * artifact). One rule, read by BottomTabBar (to render) and Navigation (to step
 * aside): on phones a signed-in user gets the bottom tab bar INSTEAD of the top
 * nav. Desktop is never affected — both components scope it with md: classes.
 *
 * Hidden:
 *  - signed out, or while auth is resolving — visitors keep the top nav with
 *    its Sign in / Sign up;
 *  - while a page takes the whole screen (siteNavAutoHide — the trip planner,
 *    whose own six tabs replace the app's);
 *  - on flows with their own full-width bottom bar or no place for the app's
 *    navigation (auth/onboarding, admin, the walking-tour builder).
 */
const HIDDEN_PREFIXES = [
  '/welcome', '/signin', '/signup', '/verify-email', '/forgot-password', '/reset-password',
  '/admin',
];
const HIDDEN_PATTERNS = [
  /^\/walking-tours\/[^/]+\/edit/,
];

export function isTabBarRoute(pathname) {
  if (HIDDEN_PREFIXES.some((p) => pathname === p || pathname.startsWith(`${p}/`) || pathname.startsWith(`${p}?`))) return false;
  if (HIDDEN_PATTERNS.some((re) => re.test(pathname))) return false;
  return true;
}

export function useBottomTabBarVisible() {
  const { currentUser, authLoading } = useAuth();
  const location = useLocation();
  const pageWantsWholeScreen = useSiteNavHidden();
  return !!currentUser && !authLoading && !pageWantsWholeScreen && isTabBarRoute(location.pathname);
}
